import "./Home.css";

import Landing from "../../../components/website/Landing/Landing";
import CategoriesShowcase from "../../../components/website/Products/ProductCard/CategoriesShowcase";

export default function HomePage ()
{
  return (
    <>
      <Landing />
      <CategoriesShowcase />
    </>
  );
}
